<template>
  <div class="form-item">
    <button class="lang-select" type="button" @click="enablePopup()">
      {{valueLabel}}
      <span class="glyphicon glyphicon-chevron-down"></span>
    </button>
  </div>
</template>
<script>
import {fieldMixin} from '../../mixin/field'
import {miniFieldMixin} from '../../mixin/minifield'
import vSelect from 'vue-select'
import Vue from 'vue'
Vue.component('v-select', vSelect)

export default {
  name: "TargetLanguage",
  mixins: [
    fieldMixin,
    miniFieldMixin(function(value){
      return(value.length > 0)
    })
  ],
  components: [
    vSelect
  ],
  props: [
    "popup"
  ],
  computed: {
    valueLabel() {
      return (
        this.fieldValue$ == '' ? this.label : this.fieldValueLabels
      )
    },
    fieldValueLabels() {
      let labels = []
      this.fieldValue.forEach(elem => {
        labels.push(elem['label'])
      })
      return labels.join(', ')
    }
  },
  methods: {
    enablePopup() {
     this.$emit('update:popup', true)
    }
  },
  watch: {
    //külső változtatás figyelése
    fieldValue: function(val) {
      this.fieldValue$ = val
    }
  }
}
</script>
